<template>
	<div class="public-mask">
		<div class="public-content">
			<div class="public-title">
				<span>{{entrust.caseNo}}</span>
				<i class="el-icon-close" @click="closeMask"></i>
			</div>
			<div class="public-box">
				<div class="public-item">
					<div class="public-item-title">
						委托人信息
					</div>
					<div class="public-item-area" v-loading="loading">
						<div class="public-unit">
							<div class="key">
								委托机构：
							</div>
							<div class="value">
								{{entrust.entrustmentOrganName}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系人：
							</div>
							<div class="value">
								{{entrust.contacts}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系方式：
							</div>
							<div class="value">
								{{entrust.phone}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								委托人：
							</div>
							<div class="value">
								{{entrust.entrustmentName}}
							</div>
						</div>
						<div class="public-unit-mid">
							<div class="key">
								地址：
							</div>
							<div class="value">
								{{entrust.address}}
							</div>
						</div>
						<div class="public-unit" v-if="userType==1">
							<div class="key">
								被鉴定人：
							</div>
							<div class="value">
								{{entrust.identifiedName}}
							</div>
						</div>
						<div class="public-unit-mid" v-if="userType==1">
							<div class="key">
								证件号码：
							</div>
							<div class="value">
								{{entrust.identifiedCertificateNo}}
							</div>
						</div>
					</div>
				</div>
				<div class="public-item">
					<div class="public-item-title">
						补充鉴定意见（必填）
					</div>
					<div class="public-item-area">
						<div class="public-textarea">
							<el-input type="textarea" :rows="3" placeholder="请输入补充鉴定意见" v-model="opinion">
							</el-input>
						</div>
					</div>
				</div>
				<div class="public-item">
					<div class="public-item-title">
						鉴定人（多选）
					</div>
					<div class="public-item-area">
						<div class="professor">
							<el-select style="width: 100%;" v-model="professor" placeholder="请选择鉴定人(多选)" multiple
								allow-create filterable @change="professorChange">
								<el-option v-for="(item,index) in professorList" :key="index" :label="item.name"
									:value="item.name"></el-option>
							</el-select>
						</div>
						<div class="public-item-hint">如果您需要输入不在列表中的鉴定人，请您在输入一次姓名后于列表中选择该新增的鉴定人</div>
					</div>
				</div>
				<div class="public-upload">
					<div class="public-upload-key">
						补充意见书：
					</div>
					<div class="public-upload-area">
						<el-upload class="upload-demo" :action="uploadSrc" :on-preview="handlePreview"
							:on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :data="{id:id}"
							:on-exceed="handleExceed" :file-list="fileList" :on-success="handleSuccess"
							accept=".doc,.docx">
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传doc/docx文件</div>
						</el-upload>
					</div>
				</div>
				<div class="public-submit">
					<el-button type="success" :loading="noRepeat" @click="submitForm">提交鉴定</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'replenish',
		props: ['id', 'userType'],
		data() {
			return {
				entrust: {
					caseNo: '',
					entrustmentOrganName: '',
					contacts: '',
					entrustmentName: '',
					identifiedName: '',
					identifiedCertificateNo: '',
					appraisalRecordList: [],
					entrustedMattersName: '',
					supplement: '',
					identificationAgin: '',
					purpose: '',
					requirement: '',
					caseAbstract: '',
					materialCatalogue: '',
					payType: '',
					estimatedCost: '',
					payTypeName: '',
					organization: {
						organName: '',
						licenceNo: '',
						contacts: '',
						phone: '',
						email: '',
					},
				},
				opinion: '',
				fileList: [

				],
				uploadSrc: '',
				fileName: '',
				noRepeat: false,
				loading: true,
				professorList: [],
				professor: ''
			};
		},
		methods: {
			professorChange(e) {
				console.log(e)
			},
			closeMask() {
				this.$emit('closeExpertise')
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handleSuccess(res, file) {
				this.fileName = res.data.fileName
			},
			submitForm() {
				if (this.opinion == '') {
					this.$message.error('请填写鉴定意见后再提交！');
					return
				}
				if (this.professor == '') {
					this.$message.error('请您选择鉴定人！');
					return
				}
				if (this.fileName == '') {
					this.$message.error('请您上传鉴定意见书！');
					return
				}
				this.$confirm('由于赋码过程需要一定时间，请耐心等待，请不要再次上传文件。', '提示', {
					confirmButtonText: '确定',
					type: 'warning',
					showCancelButton: false
				}).then(() => {}).catch(() => {});
				this.noRepeat = true
				this.$api.saveReplenish({
					id: this.$props.id,
					appraisalOpinion: this.opinion,
					documentName: this.fileName,
					appraiser: this.professor.join(',')
				}, res => {
					if (res.code == 200) {
						this.$message({
							message: '保存鉴定意见成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.noRepeat = false
								this.freshList()
								this.closeMask()
							}
						});
					} else {
						this.noRepeat = false
					}
				})
			},
			freshList() {
				this.$emit('freshList')
			},
			getData() {
				this.$api.findCaseInformationById({
					'id': this.id
				}, res => {
					this.entrust = res.data
					this.loading = false
				})
			},
			getProfessorList() {
				this.$api.getProfessorList({}, res => {
					console.log(res)
					this.professorList = res.data
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			console.log(this.$props.userType);
			this.uploadSrc = this.$pub.requestUrl + 'uploadSupplementDocument'
			this.getData()
			this.getProfessorList()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	@import url("../global.less");
</style>